class AbasimAdvisorRequest {
  constructor(details) {
    this.details = details;
    this.dialog = details.querySelector('[data-advisor-dialog]');
    this.closeButtons = details.querySelectorAll('[data-advisor-close]');
    this.handleKeydown = this.handleKeydown.bind(this);

    this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
    details.addEventListener('toggle', () => this.onToggle());
    this.dialog?.addEventListener('keydown', this.handleKeydown);
  }

  onToggle() {
    document.body.classList.toggle('advisor-dialog-open', this.details.open);

    if (this.details.open) {
      window.setTimeout(() => {
        const focusTarget = this.dialog?.querySelector('input, button, textarea');
        focusTarget?.focus();
      }, 0);
    }
  }

  close() {
    this.details.open = false;
    this.details.querySelector('summary')?.focus();
  }

  handleKeydown(event) {
    if (event.key !== 'Tab') return;

    const focusable = [...this.dialog.querySelectorAll('button, input, textarea, select, a[href]')].filter(
      (element) => !element.disabled && element.offsetParent !== null,
    );
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-advisor-request]').forEach((details) => new AbasimAdvisorRequest(details));

  const successfulRequest = document.querySelector('[data-advisor-success]');
  if (successfulRequest) {
    const request = successfulRequest.closest('[data-advisor-request]');
    if (request) request.open = true;
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openRequest = document.querySelector('[data-advisor-request][open]');
    if (openRequest) openRequest.open = false;
  });
});
